/**
 * Shared API configuration for all services
 */

// Get the appropriate API URL based on environment
export const getApiUrl = (): string => {
  let baseUrl: string;

  // Check if in Vercel
  if (import.meta.env.VERCEL) {
    const env = import.meta.env.VERCEL_ENV || 'development';
    if (env === 'production') {
      baseUrl = 'https://org-monorepo-production.up.railway.app';
    } else {
      baseUrl = 'https://org-monorepo-development-f039.up.railway.app';
    }
  }
  // Use configured API URL if available
  else if (import.meta.env.VITE_API_URL) {
    baseUrl = import.meta.env.VITE_API_URL;
  }
  // Fallback to localhost
  else {
    baseUrl = 'http://localhost:8000';
  }

  // Ensure URL doesn't end with a trailing slash
  return baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
};

// API Configuration
export const API_CONFIG = {
  // Base URL for API requests - always use full URL for API calls
  API_BASE_URL: getApiUrl(),

  // For frontend routes - in development, use relative URLs to leverage Vite's proxy
  // In production, use the full URL
  BASE_URL: import.meta.env.DEV ? 'http://localhost:8000' : getApiUrl(),

  // API Key for pre-auth endpoints
  API_KEY: import.meta.env.VITE_FRONTEND_API_KEY || '',

  // Environment information
  IS_DEV: import.meta.env.DEV,
};

// Log critical configuration warnings
if (!import.meta.env.VITE_API_URL && !import.meta.env.DEV) {
  console.warn('VITE_API_URL is not set! Falling back to default URL.');
}

if (!import.meta.env.VITE_FRONTEND_API_KEY) {
  console.warn('VITE_FRONTEND_API_KEY is not set! Authentication for pre-auth endpoints may fail.');
}
